import Ext from '../vendor/ExtCore';
import Chaos from './Chaos';
import ChaosContainer from './Container';

export default class ChaosController extends ChaosContainer {
	constructor(config = {}) {
			let initCmp;

			if (typeof config.init !== 'undefined') {
					if (config.init instanceof Function) {
							initCmp = config.init;
							delete config.init;
					} else {
							console.warn('config has a member called init, which is not a function, but overwrites original init.');
					}
			}

			const el = config.el || Ext.getBody();
			super(el, config);

			if (initCmp instanceof Function) {
					initCmp.call(this, el, config);
			}
	}
}

/**
 * Creating the prototype of the Basic plugin class.
 */
Chaos.extend(ChaosController, ChaosContainer, {
	/**
	 * Initializes the Controller.
	 *
	 * @param mixed el   The element to bind the plugin.
	 */
	init : function(el, config) {
		// call ancestor's init
		ChaosController.superclass.init.call(this, el, config);
	}
});
